"use client";

import { Button } from "@/components/ui/button";
import { useActionState, useEffect, useRef, useState } from "react";
import TestimonialFormFields from "./TestimonialFormFields";
import addTestimonial, { ActionState } from "@/actions/add-testimonial";
import { clearError } from "@/utils/utils";
import { showSuccessToast } from "@/utils/showToast";
import { useTranslations } from "next-intl";
import { ConfettiStars } from "@/animations/ConfettiStars";
import { TTestimonialFormData } from "@/schema/testimonialSchema";

const emptyData: TTestimonialFormData = {
  firstName: "",
  lastName: "",
  linkedInUrl: "",
  message: "",
};

export const initialActionState: ActionState = {
  success: false,
  errors: {},
  data: emptyData,
};

const TestimonialForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const t = useTranslations("");

  const [state, testimonialAction, isPending] = useActionState<
    ActionState,
    FormData
  >(addTestimonial, initialActionState);
  console.log("🚀 ~ TestimonialForm ~ state:", state);

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [formData, setFormData] = useState<TTestimonialFormData>(state.data);
  const [showConfetti, setShowConfetti] = useState(false);
  const successNotifiedRef = useRef(false);

  useEffect(() => {
    setErrors(state.errors || {});
    setFormData(state.data || emptyData);
  }, [state]);

  useEffect(() => {
    if (isPending) successNotifiedRef.current = false;

    if (state.success && !successNotifiedRef.current) {
      successNotifiedRef.current = true;
      showSuccessToast(state.message || t("Added successfully"));
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 3000);
      onSuccess?.();
    }
  }, [state, isPending, t, onSuccess]);

  return (
    <>
      {showConfetti && <ConfettiStars />}
      <form
        action={testimonialAction}
        className="flex flex-col gap-4"
        noValidate
      >
        <TestimonialFormFields
          errors={errors}
          data={formData}
          onChangeValue={(field, value) => {
            setFormData((prev) => ({ ...prev, [field]: value }));
            clearError(setErrors, field);
          }}
        />
        <Button disabled={isPending} type="submit" aria-label="Add Testimonial">
          {t("Add Testimonial")}
        </Button>
      </form>
    </>
  );
};

export default TestimonialForm;
